import excelToCampaignApi from 'common/src/modules/excelToCampaign/excelToCampaign.api';
import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {z} from 'zod';
import {ExcelToCampaignAgentToolName} from '../excelImport.enums';
import {columnToSignalMappingSchema} from '../excelImport.schemas';
import validateDuplicateMappings from './utils/validateDuplicateMappings';
import validateMandatorySignals from './utils/validateMandatorySignals';
import validateSegmentationMapping from './utils/validateSegmentationMapping';
import {MappingValidationError} from './validateMappingsTool.types';

const inputSchema = z.object({
  campaignId: z.number(),
  versionId: z.number(),
  mappings: z.array(columnToSignalMappingSchema),
});

function validateMappingsTool() {
  async function execute({
    input: {campaignId, versionId, mappings},
  }: ToolExecuteParams<typeof inputSchema>): Promise<ToolResult> {
    const allSignals = await excelToCampaignApi.getCampaignSignals({
      campaignId,
      versionId,
    });

    const mappingIssues: MappingValidationError[] = [
      ...validateDuplicateMappings({allSignals, mappings}),
      ...validateMandatorySignals({allSignals, mappings}),
      ...validateSegmentationMapping({allSignals, mappings}),
    ];

    return toolResult(JSON.stringify(mappingIssues));
  }

  return tool({
    name: ExcelToCampaignAgentToolName.ValidateMappings,
    description: 'Validates the mappings from headers to campaign signals.',
    execute,
    displayName: 'Validating mappings',
    inputSchema,
  });
}

export default validateMappingsTool;
